/**
 * 文案
 */

import axios from '@/utils/request'

export default {
  /* 所有订单 */
  //  getOrderList: data => axios({ url: '/api/orders/orderList', method: 'POST', data }), // 获取订单列表
  getOrderList: data => axios({ url: '/api/orders/admin/orderList', method: 'POST', data }), // 获取订单列表
  seeOrderDetails: (kkOrderId, params) => axios({ url: `/api/orders/orders/${kkOrderId}`, method: 'GET', params }), // 查询订单详情

  getUserCouponTicketDetail: (data) => axios({ url: '/api/product/userCouponTicketDetail', method: 'POST', data }), // 前后台（PC端或移动端）-获取用户已领取优惠券详情

  queryIncomeCertificate: (kkOrderid, params) => axios({ url: `/api/orders/orders/${kkOrderid}/statement`, method: 'GET', params }), // 查询收入证明

  getShopOptions: (data) => axios({ url: '/api/store/allStore', method: 'POST', data }), // 店铺下拉
  getUserOptions: (data) => axios({ url: '/api/store/allUser', method: 'POST', data }), // 用户下拉
  downloadInvoice: kkOrderId => axios({ url: `/api/orders/orders/${kkOrderId}/downloadInvoice`, responseType: 'blob' }), // 下载发票

  reviewRefund: (data) => axios({ url: `/api/orders/reviewRefund`, method: 'POST', data }), // 订单退款审核
  handleOutOfStock: (kkOrderId, data) => axios({ url: `/api/orders/orders/${kkOrderId}/outOfStock`, method: 'POST', data }), // 手动标记缺货

  orderRefundLog: kkOrderid => axios({ url: `/api/orders/orders/${kkOrderid}/orderRefund`, method: 'GET' }), // 后台-退款记录
  orderLogisticsTrackInfo: data => axios({ url: `/api/orders/logisticsTrackInfo`, method: 'post', data }), // 获取物流轨迹
  orderCancelFulfillment: data => axios({ url: `/api/orders/admin/cancelFulfillment`, method: 'PUT', data }), // 后台-接受or拒绝客户发起的取消交运请求(Shopify订单)

  // 异常订单
  getAnomalousOrderList: (data) => axios({ url: '/api/orders/orders/exception/exception', method: 'POST', data }), // 异常订单列表
  getAnomalousOrderDetails: (id, code) => axios({ url: `/api/orders/orders/exception/exception?id=${id}&platformCode=${code}`, method: 'GET' }), // 异常订单详情
  generateFromNew: (data) => axios({ url: '/api/orders/orders/exception/reset', method: 'PUT', data }), // 重新生成或标记处理

  getBehaviorConfig: (type) => axios({ url: `/api/store/user/behaviorConfig/${type}`, method: 'get' }), // 获取用户行为信息根据type
  setBehaviorConfig: (data) => axios({ url: `/api/store/user/behaviorConfig`, method: 'post', data }), // 新增或编辑用户行为配置信息
  orderGetRemark: (kkOrderId) => axios({ url: `/api/orders/admin/remark/${kkOrderId}`, method: 'get' }), // 查询-订单备注
  orderCreateRemark: (data) => axios({ url: `/api/orders/admin/remark/${data.kkOrderId}`, method: 'post', data: data.data }), // 添加订单备注

  getReplacesList: (data) => axios({ url: '/api/orders/admin/skuReplace/orderSkuReplaceList', method: 'POST', data }), // 获取替换SKU规则列表的接口
  orderSkuOpenStatus: (data) => axios({ url: '/api/orders/admin/skuReplace/orderSkuOpenStatus', method: 'PUT', data }), // 编辑替换SKU开启状态
  skuReplace: (data) => axios({ url: '/api/orders/admin/skuReplace/skuReplace', method: 'POST', data }), // 新增编辑替换SKU
  
  // 40seas
  uploadInvoice40seas: kkOrderId => axios({ url: `/api/orders/${kkOrderId}/upload/invoice40seas`, method: 'PUT' }), // 后台订单列表手动上传贷款发票

  orderCancel: data => axios({ url: `/api/orders/orders`, method: 'put', data }) // 取消订单
  
}
